import { IconButton } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

export const PrintButton = () => {
  const handlePrint = () => {
    window.print();
  };
  return (
    <IconButton onClick={handlePrint} className="no-print">
      <PrintIcon />
    </IconButton>
  );
};
